/*
 * Custom Cart pilot: neutralize Rebuy on THIS THEME ONLY.
 * Rebuy is injected store-wide via a Shopify ScriptTag (app-level, not theme
 * code), so it can't be prevented from loading by theme edits. Instead this
 * script destroys the Smart Cart as soon as it appears and hands the cart
 * back to the theme's native <cart-drawer>. Live theme is unaffected (this
 * asset only exists on the custom-cart theme).
 */
(function () {
  'use strict';

  function neutralize() {
    try {
      if (window.Rebuy && window.Rebuy.SmartCart) {
        window.Rebuy.SmartCart.skip_open = true;
        if (typeof window.Rebuy.SmartCart.destroy === 'function') {
          window.Rebuy.SmartCart.destroy();
        }
      }
    } catch (err) { /* Rebuy internals changed; CSS overrides still apply */ }

    document.documentElement.classList.remove('smart-cart--enabled');
    if (document.body) document.body.classList.remove('smart-cart--enabled');

    var smartCartEl = document.getElementById('rebuy-cart');
    if (smartCartEl) smartCartEl.remove();
  }

  ['rebuy.init', 'rebuy.ready', 'rebuy:smartcart.init', 'rebuy:smartcart.ready', 'rebuy:smartcart.show']
    .forEach(function (eventName) {
      document.addEventListener(eventName, neutralize);
    });

  var tries = 0;
  (function poll() {
    neutralize();
    if (tries++ < 40) window.setTimeout(poll, 500);
  })();

  // Cart icon always opens the NATIVE drawer, even if Rebuy grabbed the click first.
  document.addEventListener('click', function (event) {
    var icon = event.target.closest && event.target.closest('#cart-icon-bubble');
    if (!icon) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(icon);
    } else {
      window.location.href = '/cart';
    }
  }, true);
})();
